<ejs-schedule
  width='100%'
  height='550px' 
  [selectedDate]='selectedDate'
  [currentView]="currentView"
  [eventSettings]='eventSettings'
  [views]="scheduleViews"
  (actionBegin)="onActionBegin($event)"
  > </ejs-schedule>